var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2849",
    transform: "translate(-396.553 -38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M115.913,286H110v-1.389a.759.759,0,0,0-.754-.76h-.323a.759.759,0,0,0-.754.76V286h-6.037v-1.389a.759.759,0,0,0-.754-.76h-.323a.759.759,0,0,0-.754.76V286H94.091A4.109,4.109,0,0,0,90,290.124v19.609a4.109,4.109,0,0,0,4.089,4.121h21.822A4.11,4.11,0,0,0,120,309.733V290.124A4.11,4.11,0,0,0,115.913,286ZM94.091,287.98H100.3v.446a.759.759,0,0,0,.754.76h.323a.759.759,0,0,0,.754-.76v-.446h6.037v.446a.759.759,0,0,0,.754.76h.323a.759.759,0,0,0,.754-.76v-.446h5.913a2.139,2.139,0,0,1,2.128,2.144v5.853H91.963v-5.853A2.139,2.139,0,0,1,94.091,287.98Zm7.187,15.846v-6.481h7.883v6.481Zm7.883,1.368v6.684h-7.883v-6.684Zm-9.241-1.368H91.963v-6.481H99.92Zm10.6-6.481h7.522v6.481h-7.522ZM91.963,309.733v-4.539H99.92v6.684h-5.83A2.139,2.139,0,0,1,91.963,309.733Zm23.95,2.144h-5.394v-6.684h7.522v4.539A2.139,2.139,0,0,1,115.913,311.878Z",
    transform: "translate(306.551 -245.854)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    transform: "translate(414.553 57)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-pen",
    "data-name": "Icon awesome-pen",
    d: "M3.545,1.137,5.106,2.7l-3.39,3.39L.324,6.242A.293.293,0,0,1,0,5.919L.156,4.526,3.545,1.137ZM6.071.905,5.338.172a.586.586,0,0,0-.828,0l-.69.69L5.382,2.423l.69-.69a.586.586,0,0,0,0-.828Z",
    transform: "translate(417.932 60.378)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.253ad953cdead1f5a84b11d4dfaa0feb.svg";
export { ForwardRef as ReactComponent };